import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import ROUTES from '../routes';
import { View, Text } from 'react-native';

class AppNavigatorSwitch extends Component {
  _navigate(navigate, path, params) {
    navigate(path, { state: params });
  }

  _goBack(navigate) {
    navigate(-1);
  }

  generateNavigation(navigate, location) {
    return {
      navigate: (path, params) => {
        if (ROUTES[path]) {
          this._navigate(navigate, ROUTES[path].path, params);
        }
      },
      goBack: () => {
        this._goBack(navigate);
      },
      state: {
        params: location.state
      },
      getParam: (key) => {
        const { state } = location;
        return state?.[key];
      }
    };
  }

  generateRoutes(navigate, location) {
    return Object.keys(ROUTES).map((routeName, idx) => {
      const { screen: Screen, path } = ROUTES[routeName];
      const screenProps = {
        navigation: this.generateNavigation(navigate, location)
      };

      return (
        <Route
          path={path}
          key={idx}
          element={<Screen {...screenProps} />}
        />
      );
    });
  }

  render() {
    const { navigate, location } = this.props;

    return (
      <Routes>
        {this.generateRoutes(navigate, location)}
        <Route
          path="*"
          element={
            <View>
              <Text>{'404 Not Found'}</Text>
            </View>
          }
        />
      </Routes>
    );
  }
}

import { useNavigate, useLocation } from 'react-router-dom';

const AppNavigatorSwitchWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return <AppNavigatorSwitch navigate={navigate} location={location} />;
};

export default AppNavigatorSwitchWrapper;
